import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {closeFlow} from './TvActivationCodeRecoveryBlockSlice';
import successImg from './images/sentrequest.svg';
import Config from '../../../Config';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import {isMobile} from 'react-device-detect';

const SuccessMessage = (props) => {
  let cssMobile = isMobile ? ' ismobile' : '';
  return (
    <div className='success-message-view'>
      <div>
        <div className='success-message-image'>
          <Image src={successImg} />
        </div>
        <div className='caption'>
          <div>הקוד נשלח בהצלחה</div>
        </div>
      </div>

      {isMobile ? (
        <div className='info'>
          <div className='info-caption'>רוצה לצפות ב{window.Config.brand_Name_HE} TV בכל מקום ובכל זמן? יש גם אפליקציה!</div>
          <div className='info-link-wrapper'>
            <span>להורדה מ-</span>{' '}
            <a href={Config.androidTvApplicationMobileUrl} className='info-link'>
              Google Play
            </a>
          </div>
          <div className='info-link-wrapper'>
            <span>להורדה מ-</span>{' '}
            <a href={Config.iosTvApplicationUrl} className='info-link'>
              AppStore
            </a>
          </div>
        </div>
      ) : (
        <div className='info'>
          <div className='info-caption'>
            <div> רוצה לצפות ב{window.Config.brand_Name_HE} TV בכל מקום ובכל זמן? </div>
            <div>יש גם אפליקציה!</div>
          </div>
          <div className='info-link-wrapper'>
            <span>להורדה מ-</span>{' '}
            <a href={Config.androidTvApplicationUrl} className='info-link'>
              Google Play
            </a>
          </div>
          <div className='info-link-wrapper'>
            <span>להורדה מ-</span>{' '}
            <a href={Config.iosTvApplicationUrl} className='info-link'>
              AppStore
            </a>
          </div>
        </div>
      )}

      {/* <div className='close-button-wrapper'>
        <BtnSubmit text='סיום' formid='success-exit-flow-button' role='button' onclick={() => props.closeFlow()} />
        {
          //<button className='close-btn' onClick={() => props.closeFlow()}> יופי </button>
        }
      </div> */}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {isSuccsess: state.TvActivationCodeRecovery.isSuccsess};
};

const mapDispatchToProps = {
  closeFlow,
};

export default connect(mapStateToProps, mapDispatchToProps)(SuccessMessage);
